import { service } from "@server/client";
import type {
  AddGiftCardMutation,
  AddGiftCardMutationVariables,
} from "@server/gql/graphql";
import { addGiftCardMutation } from "@server/queries/cart";

export const addGiftCard = async (variables: AddGiftCardMutationVariables) => {
  try {
    const response = await service<
      AddGiftCardMutation,
      AddGiftCardMutationVariables
    >({
      query: addGiftCardMutation,
      variables,
    });

    const giftCard = response?.addGiftCard;

    if (!giftCard) {
      throw new Error("GIFT_CARD_NOT_FOUND");
    }

    return giftCard;
  } catch (error: Error | unknown) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }

    throw new Error("GIFT_CARD_UNKNOWN_ERROR");
  }
};
